import React from "react";
import { IndicatorLoader, percentDiff } from "../DashboardUtils";
var Funnel = function (_a) {
    var data = _a.data;
    // // console.log("Funnel data:", data);
    return (React.createElement("div", { className: "w-full flex flex-col items-center mb-6" }, data.map(function (step, idx) {
        var diff = typeof step.value === "number" &&
            typeof step.previous === "number"
            ? percentDiff(step.value, step.previous)
            : null;
        return (React.createElement("div", { key: step.label, className: "w-full flex flex-col items-center", style: {
                marginTop: idx === 0 ? 0 : -5,
                zIndex: data.length - idx,
            } },
            React.createElement("div", { className: "text-center font-bold py-2", style: {
                    width: "".concat(100 - idx * 15, "%"),
                    background: step.color,
                    borderRadius: idx === 0 ? "30px 30px" : "0 0 30px 30px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    color: "#222",
                } },
                React.createElement("div", { className: "text-lg" }, step.label),
                React.createElement("div", { className: "text-2xl" }, step.value == null ? (React.createElement(IndicatorLoader, null)) : (React.createElement(React.Fragment, null,
                    typeof step.value === "number"
                        ? step.value.toLocaleString("pt-BR")
                        : step.value,
                    typeof step.previous === "number" && diff !== null && (React.createElement("span", { className: "ml-2 text-sm font-semibold ".concat(diff >= 0 ? "text-green-400" : "text-red-400") },
                        diff >= 0 ? "▲" : "▼",
                        " ",
                        Math.abs(diff).toFixed(1),
                        "%"))))),
                typeof step.previous === "number" && (React.createElement("div", { className: "text-xs text-gray-600" },
                    "Anterior: ",
                    step.previous.toLocaleString("pt-BR"))))));
    })));
};
export default Funnel;
